import { render, staticRenderFns } from "./space.vue?vue&type=template&id=11aed658&scoped=true"
import script from "./space.vue?vue&type=script&lang=js"
export * from "./space.vue?vue&type=script&lang=js"
import style0 from "./space.vue?vue&type=style&index=0&id=11aed658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aed658",
  null
  
)

export default component.exports